// extracted by mini-css-extract-plugin
export default {"chip":"t18sWPA0uytvgj_K_1vZ"};